import React, { FC, useContext } from "react";
import { Button } from "@natera/material/lib/button";
import { ButtonTypes, MessageButtonType } from "@app/pippa/models";
import { APIContext, EventsContext } from "@app/pippa/provider";

interface Props {
  onClick: () => void;
  button: MessageButtonType;
  isButtonDisabled: boolean;
}

const MessageButton: FC<Props> = ({ onClick, button, isButtonDisabled }) => {
  const { userEventHandler } = useContext(EventsContext);
  const {
    apiProviderState: { chatId },
  } = useContext(APIContext);
  const { title, type } = button;

  const onClickHandler = async () => {
    switch (type) {
      case ButtonTypes.POSTBACK:
        userEventHandler(button.title, chatId);
        break;
      case ButtonTypes.RATING:
        onClick && onClick();
        break;
      case ButtonTypes.WEB_URL:
        window.open(button.payload, "_blank", "noopener,noreferrer");
        onClick && onClick();
        break;
    }
  };

  return (
    <Button
      data-testid="message-button"
      className="widget__message-button"
      disabled={isButtonDisabled}
      unelevated={button.variant !== "secondary"}
      outlined={button.variant === "secondary"}
      onClick={onClickHandler}
      loading={false}
    >
      {title}
    </Button>
  );
};

export default MessageButton;
